import ReactGA from "react-ga4";

let initialised = false;

export function initGA() {
  ReactGA.initialize(process.env['REACT_APP_G_ANALYTICS_ID'] as string);
  initialised = true;
}

export function isGAInitialised(): boolean {
  return initialised;
}

export function sendPageView(path: string) {
  if (!initialised) {
    return;
  }
  ReactGA.send({hitType: "pageview", page: path});
}
